module.exports = __webpack_public_path__ + "static/img/platformNameBack.6a0f1d6a.png";